import { createSlice } from '@reduxjs/toolkit';

import { setSignInState } from '@/app/api/baseApi';
import type { AuthenticatorData } from '@/types';

const initialState: AuthenticatorData = {
  isSignIn: false,
  isOidcSignIn: false,
  isRenderSignIn: false,
  isForceSignOut: false,
  isPreviewMode: false,
  isAdminSignIn: false,
  userId: '',
  userName: '',
  userGroupName: '',
  name: '',
};

export const authenticatorSlice = createSlice({
  name: 'authenticator',
  initialState,
  reducers: {
    signIn: (state, { payload }) => {
      const { id, username, userGroupName, name } = payload;
      state.userId = id;
      state.userName = username;
      state.userGroupName = userGroupName;
      state.isSignIn = true;
      state.isForceSignOut = false;
      state.name = name;
    },
    renderSignIn: (state, { payload }) => {
      state.isRenderSignIn = payload;
    },
    signOut: (state) => {
      state.isSignIn = false;
      state.isOidcSignIn = false;
      state.isPreviewMode = false;
      state.userName = '';
      setSignInState(false);
    },
    forceSignOut: (state) => {
      state.isForceSignOut = true;
      state.isPreviewMode = false;
      state.isAdminSignIn = false;
    },
    previewModeOn: (state) => {
      state.isPreviewMode = true;
    },
    adminSignIn: (state) => {
      state.isAdminSignIn = true;
    },
    previewModeOff: (state) => {
      state.isPreviewMode = false;
      state.isAdminSignIn = false;
    },
    oidcSignIn: (state) => {
      state.isOidcSignIn = true;
    },
  },
});

export const {
  reducer: authenticatorReducer,
  actions: {
    signIn,
    renderSignIn,
    signOut,
    forceSignOut,
    previewModeOn,
    adminSignIn,
    previewModeOff,
    oidcSignIn,
  },
} = authenticatorSlice;
